import axios from "axios";

export default axios.create({
  baseURL: "https://convert.iatkb.com",
  headers: {
    "Content-type": "application/json"
  }
});
